<template>
  <div>
      <v-card
  elevation="2"
>
             <p style="color:red;padding:10px">根据 <a href="https://www.mee.gov.cn/xxgk2018/xxgk/xxgk02/202112/t20211221_964837.html" target="_blank">《企业环境信息依法披露管理办法》</a> 第十八条：企业可以根据实际情况对已披露的环境信息进行变更；进行变更的，应当以临时环境信息依法披露报告的形式变更，并说明变更事项和理由。</p>
        </v-card> 
    <v-data-table
     
      :footer-props="{
        'items-per-page-options': [15, 30, 50],
        'show-current-page': true,
        'show-first-last-page': true,
      }"
      @pagination="setPagenation"
      :headers="tableHeaders"
      :items="tableData"
      :items-per-page="15"
      class="elevation-1"
      :server-items-length="totalCount"
    >
      <template v-slot:header>
          
        <v-btn
          elevation="2"
          color="error"
          style="margin: 8px"
          @click="jumpToAdd()"
          >新增</v-btn>
      </template>

      <template v-slot:item.IsOpen="{ item }">
        <span style="color: #74b0a7" v-if="item.IsOpen">已公开</span>
        <span v-else>未公开</span>
      </template>

      <template v-slot:item.Id="{ item }">
        <v-chip
          class="ma-2"
          @click="getPublicationDetailByID(item)"
          color="#74b0a7"
          text-color="white"
          label
        >
          查看
        </v-chip>
        <v-chip
          class="ma-2"
          @click="jumpToEdit(item)"
          color="#74b0a7"
          text-color="white"
          label
          v-if="!item.IsOpen"
        >
          编辑
        </v-chip>

        <v-chip
          class="ma-2"
          @click="toggleStatus(item)"
          color="#74b0a7"
          text-color="white"
          label
          v-if="!item.IsOpen"
        >
          设为公开
        </v-chip>
      </template>
    </v-data-table>
    <el-dialog
      :title="publicationDetailItem.CompanyName"
      :visible.sync="publicationDetailVisible"
    >
      <div class="tempPublicationInfoDetailContainer">
        <div class="pub_detail_basicInfo">
          <p>公开年度：{{ publicationDetailItem.YearNum }}</p>
        </div>
        <div class="pub_detail_item_contents">
          <p>单位名称：{{ publicationDetailItem.CompanyName }}</p>
          <p>生产地址：{{ publicationDetailItem.Address }}</p>
  <p>单位联系电话：{{ publicationDetailItem.CompanyTel }}</p>
          <p>环保负责人：{{ publicationDetailItem.HBFZR }}</p>
          <p>联系电话（环保负责人）：{{ publicationDetailItem.Tel }}</p>

          <p>企业登记注册类型：{{ publicationDetailItem.RegistType }}</p>
          <p>单位性质：{{ publicationDetailItem.CompanyNature }}</p>
          <p>所属行业：{{ publicationDetailItem.IndustryFullPath }}</p>
          <p>行政区划：{{ publicationDetailItem.RegionFullName }}</p>
          <p>变更事项：{{ publicationDetailItem.ChangeItem }}</p>
          <p>批复机关：{{ publicationDetailItem.ChangeOrg }}</p>
          <p>批复文件文号：{{ publicationDetailItem.ChangeCode }}</p>
          <p>批复时间：{{ publicationDetailItem.ChangeDate }}</p>
          <p>
            批复原文内容-附件：
            <a
              v-if="publicationDetailItem.ChangeFile"
              target="blank"
              download
              :href="FILE_BASE_URL + publicationDetailItem.ChangeFile"
              >{{ getFileName(publicationDetailItem.ChangeFile) }}</a
            >
            <span v-else>无</span>
          </p>
          <p>处罚部门：{{ publicationDetailItem.PunishmentOrg }}</p>
          <p>行政处罚决定书文号：{{ publicationDetailItem.PunishmentCode }}</p>
          <p>
            行政处罚决定书下达时间：{{ publicationDetailItem.PunishmentDate }}
          </p>
          <p>
            行政处罚决定书原文-附件：
            <a
              v-if="publicationDetailItem.PunishmentFile"
              target="blank"
              download
              :href="FILE_BASE_URL + publicationDetailItem.PunishmentFile"
              >{{ getFileName(publicationDetailItem.PunishmentFile) }}</a
            >
            <span v-else>无</span>
          </p>
          <p>判决机关：{{ publicationDetailItem.JudgmentOrg }}</p>
          <p>决书文号：{{ publicationDetailItem.JudgmentCode }}</p>
          <p>判决书下达时间：{{ publicationDetailItem.JudgmentDate }}</p>
          <p>
            判决书原文-附件：
            <a
              v-if="publicationDetailItem.JudgmentFile"
              target="blank"
              download
              :href="FILE_BASE_URL + publicationDetailItem.JudgmentFile"
              >{{ getFileName(publicationDetailItem.JudgmentFile) }}</a
            >
            <span v-else>无</span>
          </p>
          <p>生态环境损害事实：{{ publicationDetailItem.AgreementContent }}</p>
          <p>
            生态环境损害赔偿协议签订时间：{{
              publicationDetailItem.AgreementDate
            }}
          </p>
          <p>
            生态环境损害赔偿协议原文-附件：
            <a
              v-if="publicationDetailItem.AgreementFile"
              target="blank"
              download
              :href="FILE_BASE_URL + publicationDetailItem.AgreementFile"
              >{{ getFileName(publicationDetailItem.AgreementFile) }}</a
            >
            <span v-else>无</span>
          </p>
          <p>主要污染物：{{ publicationDetailItem.EmergencyContent }}</p>
          <p>最终认定等级：{{ publicationDetailItem.EmergencyLevel }}</p>
          <p>地点：{{ publicationDetailItem.EmergencyAddress }}</p>
          <p>
            突发环境事件发生的时间：{{ publicationDetailItem.EmergencyDate }}
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>



<script>
import api from "../../http/apis/apis";
import { createNamespacedHelpers } from "vuex";
const { mapMutations: companyMutations, mapState: companyState } =
  createNamespacedHelpers("company");
export default {
  data() {
    return {
      BASE_URL: "",
      FILE_BASE_URL: "",
      nowYear: "",
      publicationDetailItem: {},
      publicationDetailSubItem: {},
      publicationDetailVisible: false,
      tableData: [],
      totalCount: 0,
      searchInput: "",
      tableLoading: false,
      currentDangerListID: "",
      currentPenaltyListID: "",
      companyDangerList: [],
      penaltyList: [],
      pageData: {
        StartIndex: 0,
        Page: 1,
        Rows: 15,
        Order: "asc",
        sort: "",
      },
      dangerListPageData: {
        StartIndex: 0,
        Page: 1,
        Rows: 10,
        Order: "asc",
        sort: "",
      },
      penaltyListPageData: {
        StartIndex: 0,
        Page: 1,
        Rows: 10,
        Order: "asc",
        sort: "",
      },
      companyPictureUrl: "",
      tableHeaders: [
        {
          text: "年度",
          align: "start",
          value: "YearNum",
        },
        { text: "单位名称", value: "CompanyName" },
        { text: "是否公开", value: "IsOpen" },
        {
          text: "操作",
          sortable: false,
          value: "Id",
        },
      ],
    };
  },
  computed: {
    ...companyState(["tempPublicationInfo"]),
  },
  created() {
    this.BASE_URL = this.CONSTS.BASE_URL;
    this.FILE_BASE_URL = this.CONSTS.BASE_URL.substring(
      0,
      this.BASE_URL.length - 1
    );
    this.getNowYear();
    this.getTableData();
  },
  methods: {
    ...companyMutations(["setTempPublicationInfo"]),
    dateTrimmer(str) {
      if (str) {
        return str.split("T")[0];
      } else {
        return "";
      }
    },
    getFileName(str) {
      if (str) {
        return str.split("/").slice(-1)[0];
      } else {
        return "";
      }
    },

    async getTempPub() {},

    async getTableData() {
      this.tableLoading = true;
      const { data } = await api.companyApi.getCompanyTempPublications({
        StartIndex: this.pageData.StartIndex,
        Page: this.pageData.Page,
        Rows: this.pageData.Rows,
        Order: this.pageData.Order,
        sort: this.pageData.sort,
        Value: this.searchInput,
      });
      if (data.IsSuccessful) {
        console.info("get temp pub", data.ResultObj.Data);
        this.pageData = data.ResultObj.PagerInfo;
        this.tableData = data.ResultObj.Data;
        this.totalCount = data.ResultObj.PagerInfo.TotalRowCount;
        this.tableLoading = false;
      }
    },
    async toggleStatus(item) {
      const boo = window.confirm("已公开信息不能修改，是否继续公开？");
      if (boo) {
        const { data } = await api.companyApi.changeTempPublicationOpenStatus(
          item.Id
        );
        console.info(data);
        if (data.IsSuccessful) {
          this.getTableData();
        }
      }
    },
    getNowYear() {
      this.nowYear = new Date().getFullYear();
    },
    async initPublicationByYear(year) {
      const { data } = await api.companyApi.initPublicationByYear(year);
      if (data.IsSuccessful) {
        this.setTempPublicationInfo(data.ResultObj);
        console.info(" init item", data.ResultObj);
        this.$router.push("./tempPublicationSubmit");
      } else {
        this.$message({
          showClose: true,
          message: data.ResultMsg,
          type: "error",
        });
      }
    },
    async jumpToAdd() {
      const { data } = await api.companyApi.getTempPublicationsDetailByID(0);
      if (data.IsSuccessful) {
        this.setTempPublicationInfo(data.ResultObj);
        console.info(" init item", data.ResultObj);
        this.$router.push("./tempPublicationSubmit");
      } else {
        this.$message({
          showClose: true,
          message: data.ResultMsg,
          type: "error",
        });
      }
    },
    async jumpToEdit(item) {
      console.info(item.Id);
      const { data } = await api.companyApi.getTempPublicationsDetailByID(
        item.Id
      );
      if (data.IsSuccessful) {
        this.setTempPublicationInfo(data.ResultObj);
        console.info(" init item", data.ResultObj);
        this.$router.push("./tempPublicationSubmit");
      } else {
        this.$message({
          showClose: true,
          message: data.ResultMsg,
          type: "error",
        });
      }
    },
    setPagenation(e) {
      this.pageData = {
        Rows: e.itemsPerPage,
        Page: e.page,
        StartIndex: e.pageStart,
        Order: "asc",
        sort: "",
      };
      this.getTableData();
    },
    async getPublicationDetailByID(item) {
      const { data } = await api.companyApi.getTempPublicationsDetailByID(
        item.Id
      );
      console.info(data);
      if (data.IsSuccessful) {
        this.publicationDetailItem = data.ResultObj;
        this.publicationDetailSubItem = data.ResultObj;
        this.publicationDetailVisible = true;
      } else {
        if (data.ResultData == "loginout") {
          this.$message({
            showClose: true,
            message: "登录后才可查看公开详情!",
            type: "warning",
          });
        }
      }
    },
    async getCompanyPhotoByID(id) {
      const { data } = await api.companyApi.getCompanyPicture(id);

      if (data.IsSuccessful) {
        this.companyPictureUrl = data.ResultObj.url;
      }
    },
    async getDangerListByID(id) {
      this.currentDangerListID = id;
      const { data } = await api.companyApi.getCompanyDangerList({
        BaseCompanyId: id,
        StartIndex: this.dangerListPageData.StartIndex || 0,
        Page: this.dangerListPageData.Page || 1,
        Rows: this.dangerListPageData.Rows || 10,
        Order: this.dangerListPageData.Order || "asc",
        sort: this.dangerListPageData.sort || "",
      });
      console.info("danger", data.ResultObj);
      if (data.IsSuccessful) {
        this.companyDangerList = data.ResultObj.Data;
        this.dangerListPageData = data.ResultObj.PagerInfo;
      }
    },
    async getPenaltyListByID(id) {
      this.currentPenaltyListID = id;
      const { data } = await api.companyApi.getCompanyPenaltyList({
        CompanyId: id,
        StartIndex: this.penaltyListPageData.StartIndex || 0,
        Page: this.penaltyListPageData.Page || 1,
        Rows: this.penaltyListPageData.Rows || 10,
        Order: this.penaltyListPageData.Order || "asc",
        sort: this.penaltyListPageData.sort || "",
      });
      console.info("penalty", data.ResultObj);
      if (data.IsSuccessful) {
        this.penaltyList = data.ResultObj.Data;
        this.penaltyListPageData = data.ResultObj.PagerInfo;
      }
    },
    handleDangerSizeChange(val) {
      this.dangerListPageData.Rows = val;
      this.getDangerListByID(this.currentDangerListID);
    },
    handleDangerCurrentChange(val) {
      this.dangerListPageData.Page = val;
      this.getDangerListByID(this.currentDangerListID);
    },
    handlePenaltySizeChange(val) {
      this.penaltyListPageData.Rows = val;
      this.getPenaltyListByID(this.currentPenaltyListID);
    },
    handlePenaltyCurrentChange(val) {
      this.penaltyListPageData.Page = val;
      this.getPenaltyListByID(this.currentPenaltyListID);
    },
  },
};
</script>

<style lang="scss" scoped>
.pub_detail_item {
  border: 1px dashed lightgray;
  margin: 10px 0px;
  padding: 10px;
  width: 100%;
}
</style>